var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: _vm.cols,
            "form-context": _vm.formContext,
            icon: "inticon-autoclaim_company",
            "prevent-default-on-cancel": _vm.isCreationForm,
            title: "Firma",
          },
          on: { "cancel-form": _vm.handleCancel, save: _vm.saveFirmBasedata },
        },
        [
          _vm.showChangelogButton
            ? _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c("csp-changelog-modal", {
                    attrs: { "changelog-url": _vm.firmChangelogUrl },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h2", [_vm._v("Zugehörigkeit")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Vertriebspartner",
                  "options-loader": _vm.loadOptions("resellers"),
                  property: "reseller",
                  type: "autocomplete",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Kategorie",
                  "options-loader": _vm.loadOptions("firmCategories"),
                  property: "firmCategory",
                  required: true,
                  type: "autocomplete",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Zuordnung",
                  "options-loader": _vm.loadOptions(
                    "firmAssociationWithoutGroups",
                    { includeGroups: false }
                  ),
                  property: "firmAssociation",
                  type: "autocomplete",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Firmengruppe",
                  "options-loader": _vm.loadOptions("firmGroup"),
                  property: "firmGroup",
                  type: "autocomplete",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Gebiet",
                  "options-loader": _vm.loadOptions("areas"),
                  property: "area",
                  type: "autocomplete",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Flottenkunde",
                  property: "isFleetCustomer",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Großkunde",
                  property: "isMajorCustomer",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Haupt-Reparaturbetrieb",
                  "options-loader": _vm.loadOptions("mainCarDealerFirm", {
                    firmGroupId: _vm.formContext.form.data.firmGroup,
                    firmId: _vm.firmId,
                  }),
                  property: "mainCarDealerFirm",
                  type: "autocomplete",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("h2", [_vm._v("Adressdaten")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Name",
                  property: "name",
                  required: true,
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Name Zusatz",
                  property: "nameAffix",
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Straße",
                  property: "street",
                  required: true,
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "PLZ",
                  property: "postalCode",
                  required: true,
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Ort",
                  property: "city",
                  required: true,
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Land",
                  "options-loader": _vm.loadOptions("countries"),
                  property: "country",
                  required: true,
                  type: "autocomplete",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  dependencies: ["country"],
                  "form-context": _vm.formContext,
                  label: "Region",
                  "options-loader": _vm.loadOptions("regions", {
                    countryId: _vm.formContext.form.data.country,
                  }),
                  property: "region",
                  required: true,
                  type: "autocomplete",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("h2", [_vm._v("Kontaktdaten")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "E-Mail administrativ",
                  property: "email",
                  required: true,
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "E-Mail Benachrichtigung",
                  property: "notificationEmail",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "E-Mail Datenschutzbeauftragter",
                  property: "dataProtectionCommissionerMail",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "zusätzliche E-Mail für Rückrufbitten",
                  property: "callbackEmail",
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "E-Mail QM Beauftragte",
                  property: "qmCommissionerMail",
                  type: "textarea",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Telefon",
                  property: "phone",
                  required: true,
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Internet",
                  property: "internet",
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showActionButtons
            ? _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-col", { attrs: { cols: "6" } }),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-right", attrs: { cols: "6" } },
                    [
                      _vm.showDeleteButton
                        ? _c(
                            "b-button",
                            { on: { click: _vm.openDeleteConfirmationModal } },
                            [
                              _vm._v(
                                "\n                Firma löschen\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: { "cancel-title": "Abbrechen", title: "Firma löschen" },
              on: { ok: _vm.deleteFirm },
              model: {
                value: _vm.isDeleteConfirmationModalOpen,
                callback: function ($$v) {
                  _vm.isDeleteConfirmationModalOpen = $$v
                },
                expression: "isDeleteConfirmationModalOpen",
              },
            },
            [_vm._v("\n        Wollen Sie die Firma wirklich löschen?\n    ")]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }